import React, { useCallback } from 'react';
import { CONTAINS, EQUALS, HAS_KEY, ONE_OF, STRICT_EQUAL } from '../../../../../../../operators';
import styles from './ConditionValue.module.scss';
import RemoveValueIcon from './RemoveValueIcon';
import SelectValue from './SelectValue';
import TextInputValue from './TextInputValue';

function ConditionValue(props) {
    const { operator, value, onChange } = props;

    const handleRemoveValue = useCallback(() => {
        onChange('');
    }, [onChange]);

    let content;
    switch (operator.id) {
        case EQUALS:
        case CONTAINS:
            content = <TextInputValue operator={operator} value={value} onChange={onChange} />;
            break;
        case ONE_OF:
        case STRICT_EQUAL:
        case HAS_KEY:
            content = <SelectValue operator={operator} value={value} onChange={onChange} />;
            break;
        default:
            content = null;
    }

    return (
        <div className={styles.ConditionValue}>
            <RemoveValueIcon className={styles.removeValue} value={value} onClick={handleRemoveValue} />
            {content}
        </div>
    );
}

export default ConditionValue;
